import { FC, useEffect } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface AttachProps {
  id_usuario: string;
  id_organizacion: string;
}

const AttachModal: FC<Props> = ({ isOpen, setIsOpen }) => {
  const { isAttaching, rdsUser, allOrgs, isLoadingOrgs, attachUser } =
    useSingleUserControl();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<AttachProps>();

  const handleClose = () => {
    if (!isAttaching) {
      setIsOpen(false);
    }
  };

  // Cerramos el popup cuando se ejecute la función
  useEffect(() => {
    if (!isAttaching && isOpen) {
      handleClose();
    }
  }, [isAttaching]);

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: AttachProps) => {
    console.log(data);
    attachUser(data);
  };

  useEffect(() => {
    if (rdsUser) {
      reset({
        id_usuario: rdsUser.id_usuario,
        id_organizacion: "",
      });
    }
  }, [rdsUser]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        {isLoadingOrgs ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <Typography
              id="edit-subscription-modal-title"
              variant="h6"
              component="h2"
            >
              Seleccionar organización
            </Typography>

            {/* Campo organización */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ mt: 3, fontWeight: 500 }}>
                Organización
              </Typography>
              <Controller
                name="id_organizacion"
                control={control}
                rules={{ required: "La organización es obligatoria" }}
                render={({ field }) => (
                  <FormControl sx={{ mt: 1 }} fullWidth>
                    <Select
                      {...field}
                      value={field.value || ""}
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!errors.id_organizacion}
                      disabled={isAttaching}
                    >
                      {allOrgs.map((org) => (
                        <MenuItem
                          key={org.id_organizacion}
                          value={org.id_organizacion}
                        >
                          {org.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Box>

            <Box
              sx={{
                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end",
                gap: 3,
                mt: 3,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setIsOpen(false)}
                disabled={isAttaching}
                sx={{
                  borderRadius: 14,
                  border: "1px solid #336B87",
                  color: "#336B87",
                  "&:hover": {
                    backgroundColor: "#336B87",
                    color: "#EEF3F6",
                  },
                }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isAttaching}
                type="submit"
              >
                {isAttaching ? "Anexando" : "Anexar"}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AttachModal;
